import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {injectIntl} from 'react-intl';
import messages from '../../../../../../res/translations/messages';
import Operator from '../Operator';
import Value from '../Value';
import QuestionId from '../QuestionId';

class ParameterBuilder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {expression, intl} = this.props;
        let operator;
        switch (expression.condition.operator) {
            case constants.EDITOR_OPERATORS.EQ:
                operator = intl.formatMessage({...messages.filters.operators.equal});
                break;
            case constants.EDITOR_OPERATORS.NEQ:
                operator = intl.formatMessage({...messages.filters.operators.notEqual});
                break;
        }

        if (!operator) {
            return null;
        }

        return (
            <>
                <QuestionId id={expression.id} />
                <Operator operator={operator} />
                <Value value={expression.condition.value} />
            </>
        );
    }
}

export default injectIntl(ParameterBuilder);
